// src/utils/OrderPersistence.js

import tenantStorage from '../services/tenantStorage';

// Save table orders to tenant storage
const saveTableOrders = async (tableOrders) => {
    try {
        // Save each order individually
        for (const [tableKey, orderData] of Object.entries(tableOrders)) {
            await tenantStorage.saveOrder(tableKey, orderData);
        }
    } catch (error) {
        console.error('Failed to save table orders to tenant storage:', error);
    }
};

// Load table orders from tenant storage
const loadTableOrders = async () => {
    try {
        const { orders } = await tenantStorage.getOrders();
        return orders || {};
    } catch (error) {
        console.error('Failed to load table orders from tenant storage:', error);
        return {};
    }
};

// // Clear table orders from tenant storage
// const clearTableOrders = async () => {
//     try {
//         await tenantStorage.clearAllOrders();
//     } catch (error) {
//         console.error('Failed to clear table orders from tenant storage:', error);
//     }
// };

// Save a specific table order
const saveTableOrder = async (tableNumber, orderData) => {
    try {
        await tenantStorage.saveOrder(tableNumber, orderData);
    } catch (error) {
        console.error(`Failed to save order for table ${tableNumber}:`, error);
    }
};

// Delete a specific table order
const deleteTableOrder = async (tableNumber) => {
    try {
        await tenantStorage.deleteOrder(tableNumber);
    } catch (error) {
        console.error(`Failed to delete order for table ${tableNumber}:`, error);
    }
};

const ensureOrderPersistence = () => {
    // Add event listener for beforeunload to save state
    window.addEventListener('beforeunload', async () => {
        // Note: Most browsers limit what you can do in beforeunload
        // The tenant storage automatically syncs, so this is less critical
        console.log('Page unloading - tenant storage handles persistence automatically');
    });
};

export {
    saveTableOrders,
    loadTableOrders,
    // clearTableOrders,
    saveTableOrder,
    deleteTableOrder,
    ensureOrderPersistence
};